<template>
  <div class="d-flex flex-row align-stretch mb-8 avatar-wrapper">
    <div>
      <v-skeleton-loader
        v-if="avatarLoading"
        width="200"
        height="200"
        type="card-avatar"
        tile
      ></v-skeleton-loader>
      <image-pic
        v-else-if="image_url"
        :image_url="image_url"
        tile
        :size="size"
      ></image-pic>
    </div>

    <div class="d-flex flex-column justify-space-around ml-6">
      <v-btn
        text
        class="text-capitalize font-weight-bold text-light-blue"
        @click="showCropperModal = !showCropperModal"
        :loading="avatarLoading"
      >
        <img src="@/assets/icons/icon-image.svg" class="mr-2" alt />{{ label }}
      </v-btn>
    </div>

    <image-cropper
      v-model="showCropperModal"
      :ratio="ratio"
      @change="imageChange"
    />
  </div>
</template>

<script>
import { mdiImagePlus, mdiDelete } from '@mdi/js'
import ImageCropper from '@/components/modals/ImageCropper'
import ImagePic from '@/components/Image'

export default {
  props: {
    image_url: null,
    avatarLoading: {
      type: Boolean,
      default: false,
    },
    ratio: {
      type: [Number, String],
      default: 1 / 1,
    },
    label: {
      type: [Number, String],
      default: 'Upload Image',
    },
    size: {
      type: [String],
      default: '1',
    },
    type: {},
  },
  components: {
    ImageCropper,
    ImagePic,
  },
  data() {
    return {
      icons: {
        addImage: mdiImagePlus,
        delete: mdiDelete,
      },
      loading: false,
      showCropperModal: false,
      deleteConfirmDialog: false,
      snackbar: {
        show: false,
        message: null,
      },
    }
  },
  methods: {
    imageChange(image) {
      let type = this.type
      this.$emit('change', { image, type })
    },
    showSnackbar(message) {
      this.snackbar.message = message
      this.snackbar.show = true
    },
  },
}
</script>
